import { useEffect, useState } from "react"
import { Button } from "./ui"

export function UpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    function handleUpdate() {
      setUpdateAvailable(true)
    }

    window.addEventListener("sw-update-available", handleUpdate)
    return () => window.removeEventListener("sw-update-available", handleUpdate)
  }, [])

  if (!updateAvailable) return null

  function handleReload() {
    navigator.serviceWorker.ready.then((registration) => {
      registration.waiting?.postMessage({ type: "SKIP_WAITING" })
    })
  }

  return (
    <div className="admin-pwa-banner" role="status">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">
          Update Ready
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-900">
          A new admin build is available.
        </p>
        <p className="mt-1 text-sm text-slate-500">
          Reload when convenient to apply the latest fixes and UI updates.
        </p>
      </div>
      <Button type="button" className="w-full sm:w-auto" onClick={handleReload}>
        Refresh App
      </Button>
    </div>
  )
}
